import customerConfig from "@/customer/config.json"
import { getInjectedAppName, getInjectedOrganizationName } from "@/lib/runtime-branding"

/**
 * App + company branding for the Segment Analysis module. Precedence:
 * server-injected branding (see lib/runtime-branding.ts) > the tenant's
 * build-time `customer/config.json` (the same `app_name` / `organization_name`
 * the rest of the app uses) > a generic default. The module is generic/
 * internal by default — these variables drive every brand label so nothing
 * is hard-coded to a single customer. A tenant (e.g. a signed customer) sets
 * `organization_name` and the KPIs/labels follow with no code change.
 */
const cfg = (customerConfig as { config?: { app_name?: string; organization_name?: string } })
  .config

/** Product/app name (e.g. "Hello AI"). */
export const APP_NAME: string = getInjectedAppName() ?? cfg?.app_name ?? "Hello AI"

/**
 * Company/organisation whose sales + fit the module reports on.
 * Uses `organization_name` only — never falls back to `app_name` / product name
 * (e.g. "Hello AI"), which is the service brand, not the tenant company.
 * When unset (internal/default build), labels use the neutral "Company".
 */
export const COMPANY_NAME: string =
  getInjectedOrganizationName()?.trim() || cfg?.organization_name?.trim() || "Company"
